import { useAppSelector } from 'flow/hooks/useRedux';
import { Customer } from 'flow/types/Customer';

import { TypedMap } from 'flow/types/TypedMap';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';

interface CustomerHook {
    ownCustomer: TypedMap<Customer>;
    ownCustomerKey: string;
}

const useCustomer = (extensionKey: string = null): CustomerHook => {
    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);

    if (!extensionKey) {
        extensionKey = ownExtensionKey;
    }

    const ownCustomer = useAppSelector((state) =>
        state.customer.get(extensionKey),
    );
    const ownCustomerKey = ownCustomer?.get('key');

    return { ownCustomer, ownCustomerKey };
};

export default useCustomer;
